import './variable.styles.scss'
export default function VariableComponent(props: { name: string }) {

    return <div className="VariableComponent">
        <i className='las la-keyboard'></i>
        <div className='name'>{props.name}</div>
    </div>

}